import React, { Component } from "react";
import GraficoTartas from "./GraficoTartas";
import GraficoRadar from "./GraficoRadar";
import GraficoRadarCoros from "./GraficoRadarCoros";
import GraficoRadarChirigotas from "./GraficoRadarChirigotas";
import GraficoRadarComparsas from "./GraficoRadarComparsas";
import GraficoRadarCuartetos from "./GraficoRadarCuartetos";
import CabeceraGrupo from "./CabeceraGrupo";
import Search from "./Search";
import Titulin from "./Titulin";
import Volver from "./Volver";
import Clave from "./Clave";
import { getMainColor } from "../utils/helpers.js";
import SVGInline from "react-svg-inline";

export default class Agrupaciones extends Component {
	constructor(props) {
		super();
		this.state = {
			fase: props.tiempo.cod,
			ide: "",
			ideSec: "",
			mainColor: ""
		};
		// BINDINGS
		this.setIdeSec = this.setIdeSec.bind(this);
	}
	componentWillMount() {
		this.setState({
			ide: this.props.match.params.ide,
			mainColor: this.props.getMainColor(this.props.match.params.ide)
		});
	}

	componentDidMount() {
		window.scrollTo(0, 0);
	}

	setIdeSec(arg) {
		this.setState({
			ideSec: arg
		});
	}

	render() {
		return (
			<div className="container graficos">
				<div className="volverCont">
					{this.props.history ? (
						<div
							onClick={e => {
								e.preventDefault();
								this.props.history.goBack();
								this.props.getMainColor("cor_x");
							}}
						>
							<SVGInline
								className="volverIcono"
								svg={`<svg width="30" height="26" viewBox="0 0 16 14" fill-rule="evenodd"><path fill=${
									this.props.mainColor
								} d="M3.4 8H16V6H3.3l5-4.7L7 0 0 7l7 7 1.3-1.3z"></path></svg>`}
							/>
							<p
								className="volverTxt"
								style={{ color: "RGBA(133, 141, 149, 1.00)" }}
							>
								Volver
							</p>
						</div>
					) : (
						""
					)}
				</div>
				{this.props.agrupaciones[this.props.match.params.ide] ? (
					<div>
						<CabeceraGrupo
							mainColor={this.props.mainColor}
							agrupaciones={this.props.agrupaciones}
							ide={this.props.match.params.ide}
							fase={this.state.fase}
						/>
						<Titulin titulo="Fases" />
						<GraficoTartas
							style={{ strokeWidth: "0px" }}
							agrupaciones={this.props.agrupaciones}
							ide={this.props.match.params.ide}
							mainColor={this.props.mainColor}
							agrupacion={this.props.agrupaciones[this.props.match.params.ide]}
						/>
						{this.props.agrupaciones[this.props.match.params.ide].cat ===
							"coro" ||
						this.props.agrupaciones[this.props.match.params.ide].cat ===
							"cuarteto" ? (
							<Titulin
								titulo={`Compara con otros ${
									this.props.agrupaciones[this.props.match.params.ide].cat
								}s`}
							/>
						) : (
							""
						)}
						{this.props.agrupaciones[this.props.match.params.ide].cat !==
							"coro" &&
						this.props.agrupaciones[this.props.match.params.ide].cat !==
							"cuarteto" ? (
							<Titulin
								titulo={`Compara con otras ${
									this.props.agrupaciones[this.props.match.params.ide].cat
								}s`}
							/>
						) : (
							""
						)}

						<Search
							setIdeSec={this.setIdeSec}
							agrupaciones={this.props.agrupaciones}
							ide={this.state.ide}
							fase={this.state.fase}
						/>
						<Clave
							mainColor={this.props.mainColor}
							agrupaciones={this.props.agrupaciones}
							ide={this.props.match.params.ide}
							ideSec={this.state.ideSec}
						/>

						{/* RADAR CORO */}
						{this.props.agrupaciones[this.props.match.params.ide]["cat"] ===
						"coro" ? (
							<div>
								<GraficoRadarCoros
									agrupaciones={this.props.agrupaciones}
									agrupacion={
										this.props.agrupaciones[this.props.match.params.ide]
									}
									ide={this.props.match.params.ide}
									ideSec={this.state.ideSec}
									mainColor={this.props.mainColor}
									tiempo={this.props.tiempo}
								/>
							</div>
						) : (
							""
						)}

						{this.props.agrupaciones[this.props.match.params.ide]["cat"] ===
						"chirigota" ? (
							<div>
								<GraficoRadarChirigotas
									agrupaciones={this.props.agrupaciones}
									agrupacion={
										this.props.agrupaciones[this.props.match.params.ide]
									}
									ide={this.props.match.params.ide}
									ideSec={this.state.ideSec}
									mainColor={this.props.mainColor}
									tiempo={this.props.tiempo}
								/>
							</div>
						) : (
							""
						)}

						{this.props.agrupaciones[this.props.match.params.ide]["cat"] ===
						"comparsa" ? (
							<div>
								<GraficoRadarComparsas
									agrupaciones={this.props.agrupaciones}
									agrupacion={
										this.props.agrupaciones[this.props.match.params.ide]
									}
									ide={this.props.match.params.ide}
									ideSec={this.state.ideSec}
									mainColor={this.props.mainColor}
									tiempo={this.props.tiempo}
								/>
							</div>
						) : (
							""
						)}
						{this.props.agrupaciones[this.props.match.params.ide]["cat"] ===
						"cuarteto" ? (
							<div>
								<GraficoRadarCuartetos
									agrupaciones={this.props.agrupaciones}
									agrupacion={
										this.props.agrupaciones[this.props.match.params.ide]
									}
									ide={this.props.match.params.ide}
									ideSec={this.state.ideSec}
									mainColor={this.props.mainColor}
									tiempo={this.props.tiempo}
								/>
							</div>
						) : (
							""
						)}
						<div className="cont_ficha_enlace">
							<h3>
								<a
									href={
										this.props.agrupaciones[this.props.match.params.ide].enlace
									}
									target="_blank"
									className="ficha_enlace"
									style={{
										color: "RGBA(133, 141, 149, 1.00)"
									}}
								>
									Ficha en Diario del Carnaval
									<SVGInline
										className="fichaIcono"
										svg={`<svg width='24' height='20' viewBox='0 0 24 20' fill-rule='evenodd'><path fill=${
											this.props.mainColor
										} d='M15.7 9.7L22 3.4V8h2V0h-8v2h4.6l-6.3 6.3z'></path><path fill=${
											this.props.mainColor
										} d='M22 18H2V4h10V0H0v20h24v-8h-2z'></path></svg>`}
									/>
								</a>
							</h3>
						</div>
					</div>
				) : (
					"Cargando"
				)}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Agrupaciones.js